// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2lb9a","header":"MessagesList_header__2PFD_","chat":"MessagesList_chat__JNsNt"};